import { Box } from "@mui/material"
import { AddOutlined } from "@mui-symbols-material/w300"
import { type FC, useEffect } from "react"
import { useFieldArray, useFormContext } from "react-hook-form"

import { Button } from "@/components/common/Button"
import { FormTextField } from "@/components/UiKit"
import type { GoodsReceiptFormValues } from "@/screens/WarehouseReceiving/subfeatures/Incoming/schemas.ts"

export const TrackingNumbersFields: FC = () => {
  const { control } = useFormContext<GoodsReceiptFormValues>()

  const { fields, append } = useFieldArray({
    name: "trackingNumbers",
  })
  const canAddContainerTrackingNumber = fields.length >= 10

  const handleAddContainerTrackingNumber = () => {
    append("")
  }

  // Ensure at least one empty tracking number field
  useEffect(() => {
    if (fields.length === 0) {
      append("")
    }
  }, [fields.length, append])

  return (
    <Box>
      {fields.map((field, index) => (
        <FormTextField
          key={field.id}
          name={`trackingNumbers.${index}` as const}
          control={control}
          label='Container/Tracking #'
          fullWidth
          placeholder='Enter container/tracking number'
          variant='outlined'
          className='mb-6'
          data-testid={`container-tracking-field-${index}`}
        />
      ))}
      {!canAddContainerTrackingNumber && (
        <Box className='flex justify-end'>
          <Button
            appearance='text'
            onClick={handleAddContainerTrackingNumber}
            startIcon={<AddOutlined />}
            data-testid='add-container-button'
          >
            Container/Tracking #
          </Button>
        </Box>
      )}
    </Box>
  )
}
